/* src/app/workshop/components/settings/checkareas/checkareas.component.scss */
/*# sourceMappingURL=checkareas.component.css.map */
